import { Language } from "../types";
import { useFeatureServices } from "../use-feature-services";

export const getLang = () => {
  const { language } = useFeatureServices()['locale-service'];
  return language as Language;
}

export const getTranslations = (lang?: Language) => {
  return lang ? require(`./${lang}.json`) : require(`./${getLang()}.json`);
}
